import {
  Bath,
  Car,
  Flower2,
  Fuel,
  Leaf,
  Sprout,
  TreePine,
  Waves,
  Briefcase,
  DoorOpen,
  Package,
  Shirt,
  Toilet,
  Trees,
  Tv,
  Utensils,
  Bed,
  BedDouble,
  Brush,
  CircleEllipsis,
  CookingPot,
  Droplets,
  FlaskConical,
  Hand,
  House,
  Layers,
  Milk,
  PaintBucket,
  ShowerHead,
  Sofa,
  Sparkles,
  SprayCan,
  SquareStack,
  Trash2,
  WashingMachine,
  type LucideIcon,
} from 'lucide-react-native';
import type { ProductCategory, ProductIcon, RoomIcon } from '@hogar/shared';

export const roomIcons: Record<RoomIcon, LucideIcon> = {
  'cooking-pot': CookingPot,
  bath: Bath,
  'shower-head': ShowerHead,
  toilet: Toilet,
  'bed-double': BedDouble,
  bed: Bed,
  sofa: Sofa,
  utensils: Utensils,
  tv: Tv,
  briefcase: Briefcase,
  'washing-machine': WashingMachine,
  'door-open': DoorOpen,
  trees: Trees,
  house: House,
  'flower-2': Flower2,
  'tree-pine': TreePine,
  waves: Waves,
  sprout: Sprout,
  car: Car,
};

export const productIcons: Record<ProductIcon, LucideIcon> = {
  milk: Milk,
  droplets: Droplets,
  'spray-can': SprayCan,
  'trash-2': Trash2,
  layers: Layers,
  'square-stack': SquareStack,
  hand: Hand,
  sparkles: Sparkles,
  'flask-conical': FlaskConical,
  package: Package,
  shirt: Shirt,
  fuel: Fuel,
  leaf: Leaf,
  sprout: Sprout,
};

export const categoryIcons: Record<ProductCategory, LucideIcon> = {
  general: SprayCan,
  bathroom: Bath,
  kitchen: CookingPot,
  floors: PaintBucket,
  disposables: Trash2,
  other: CircleEllipsis,
  garden: Sprout,
};

export { Brush };
